import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TgGridModule } from '@trademe/tangram';
import { MotorsCannotEditSomethingMessageSectionModule } from 'libs/motors-ui/src/lib/sections/motors-cannot-edit-something-message-section/motors-cannot-edit-something-message-section.module';
import { MotorsDescriptionAndPhotosDescriptionSectionModule } from 'libs/motors-ui/src/lib/sections/motors-description-and-photos-description-section/motors-description-and-photos-description-section.module';
import { MotorsDescriptionAndPhotosPhotoSectionModule } from 'libs/motors-ui/src/lib/sections/motors-description-and-photos-photo-section/motors-description-and-photos-photo-section.module';
import { MotorsDescriptionAndPhotosVideoSectionModule } from 'libs/motors-ui/src/lib/sections/motors-description-and-photos-video-section/motors-description-and-photos-video-section.module';
import { TmDateComponent } from 'libs/trademe-core-ui/src/lib/tm-date/tm-date.component';
import { BoatsAndMarineDescriptionAndPhotosPageComponent } from './motors-description-and-photos-page.component';

@NgModule({
    imports: [
        CommonModule,
        TgGridModule,
        MotorsDescriptionAndPhotosDescriptionSectionModule,
        MotorsDescriptionAndPhotosPhotoSectionModule,
        MotorsDescriptionAndPhotosVideoSectionModule,
        MotorsCannotEditSomethingMessageSectionModule
    ],
    declarations: [BoatsAndMarineDescriptionAndPhotosPageComponent],
    providers: [TmDateComponent],
    exports: [BoatsAndMarineDescriptionAndPhotosPageComponent]
})
export class BoatsAndMarineDescriptionAndPhotosPageModule { }
